<script>
import {mapStores} from "pinia";
import {useAuthStore} from "@/stores/auth";
import ImageProduct from "@/components/products/viewProduct/ImageProduct.vue";

export default {
  name: 'ProductListOrder',
  components: {ImageProduct},
  computed: {
    ...mapStores(useAuthStore)
  }
}
</script>

<template>
  <table class="w-full text-left font-medium text-gray-900 dark:text-white md:table-fixed">
    <tbody class="divide-y divide-gray-200 dark:divide-gray-800">
    <tr v-for="(productCart, index) in authStore.getCart.productsCart" :key="index">
      <td class="whitespace-nowrap py-4 md:w-[384px]">
          <a :href="`/boutique/${productCart.products.tag}`" target="_blank" class="flex items-center aspect-square w-10 h-10 shrink-0">
            <image-product size="w-28" :product="productCart.products" />
          </a>
      </td>
      <td>
        <a :href="`/boutique/${productCart.products.tag}`" target="_blank" class="hover:underline">
          {{ productCart.products.title }}
        </a>
      </td>
      <td class="p-4 text-base font-normal text-gray-900 dark:text-white">
        x{{ productCart.quantity }}
      </td>
      <td class="p-4 text-right text-base font-bold text-gray-900 dark:text-white">
        {{ productCart.quantity * productCart.products.price }}€
      </td>
    </tr>
    </tbody>
  </table>
</template>

